import { gql } from "apollo-angular";


export const CREATE_NEWS_MUTATION = gql`
  mutation CreateNews($createNewsInput: CreateNewsInput!) {
    createNews(createNewsInput: $createNewsInput) {
      newsId
      audience
      type
      title
      subTitle
      description
      photo
      link
      status
      dateUpdated
      dateCreated
    }
  }
`;

export const UPDATE_NEWS_MUTATION = gql`
  mutation UpdateNews($newsId: HashedId!, $updateNewsInput: UpdateNewsInput!) {
    updateNews(newsId: $newsId, updateNewsInput: $updateNewsInput) {
      newsId
      audience
      type
      title
      subTitle
      description
      photo
      link
      status
      dateUpdated
      dateCreated
    }
  }
`;
